import { GastoProyectoItem, ProyectosPlataformaService } from "../../../shared/generated/grpc/plataforma_proyectos_pb";
import { GastoResponse } from "../../../shared/response/proyectos/ProyectoResponse";
import { GastoPayload } from "../../../shared/services/api/payload/proyectos/GastoPayload";
import { dateToMs, grpcCall, grpcClient } from "../../../shared/services/grpc/grpcCall";

/**
 * Gastos reales de un ítem del proyecto (`ProyectosPlataformaService`, gRPC). `itemId` = id del CatalogoItem.
 * Los gastos no se cachean (viven en el detalle del proyecto); tras crear/eliminar se recarga el detalle.
 */
export class GastoService {
  static readonly instance = new GastoService();
  private constructor() {}

  /** Alta o edición (`GuardarGasto`); el total lo calcula el servidor. */
  async save(proyectoId: string, itemId: string, payload: GastoPayload): Promise<GastoResponse> {
    const r = await grpcCall(() => grpcClient(ProyectosPlataformaService).guardarGasto({
      id: payload.id,
      proyectoId,
      itemId,
      fecha: dateToMs(payload.fecha) ?? BigInt(Date.now()),
      cantidadReal: payload.cantidadReal,
      precioUnitarioReal: BigInt(Math.round(payload.precioUnitarioReal)),
      proveedor: payload.proveedor ?? undefined,
      observaciones: payload.observaciones ?? undefined,
    }));
    return toGastoResponse(r);
  }

  /** Baja lógica (`EliminarGasto`), idempotente. */
  async delete(gastoId: string): Promise<void> {
    await grpcCall(() => grpcClient(ProyectosPlataformaService).eliminarGasto({ id: gastoId }));
  }
}

/** Mensaje gRPC del gasto → `GastoResponse`. Lo reusa el detalle del proyecto. */
export function toGastoResponse(g: GastoProyectoItem): GastoResponse {
  return {
    id: g.id,
    fecha: new Date(Number(g.fecha)).toISOString(),
    cantidadReal: g.cantidadReal,
    precioUnitarioReal: Number(g.precioUnitarioReal),
    total: Number(g.total),
    proveedor: g.proveedor ?? null,
    observaciones: g.observaciones ?? null,
    isEliminado: false,
    referencia: g.referencia ?? null,
  };
}
